import { Link } from 'react-router-dom';
import { SITE } from '@/config/site';

const columns = [
  {
    title: 'Servicios',
    links: [
      { label: 'Inteligencia Artificial', to: '/inteligencia-artificial' },
      { label: 'Agentes IA', to: '/agentes-ia' },
      { label: 'Desarrollo', to: '/desarrollo-software' },
      { label: 'Integraciones', to: '/integraciones' },
      { label: 'SAP Business One', to: '/sap-business-one' },
      { label: 'Arquitectura', to: '/arquitectura' },
    ],
  },
  {
    title: 'Soluciones',
    links: [
      { label: 'Automatizar procesos', to: '/soluciones' },
      { label: 'Conectar tu ERP', to: '/soluciones' },
      { label: 'Crear un SaaS', to: '/soluciones' },
      { label: 'Incorporar IA', to: '/soluciones' },
      { label: 'Modernizar sistemas', to: '/soluciones' },
    ],
  },
  {
    title: 'Productos',
    links: [
      { label: 'PriviRooms', to: '/proyectos' },
      { label: 'APR-Online', to: '/proyectos' },
      { label: 'Contoo', to: '/proyectos' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Nosotros', to: '/nosotros' },
      { label: 'Contacto', to: '/contacto' },
      { label: 'Privacidad', to: '/privacidad' },
      { label: 'Términos', to: '/terminos' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900/70 border-t border-background-800/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-16 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src={SITE.logo}
                alt="Logo de ACOMA"
                title="ACOMA — Inteligencia Artificial, Software e Integraciones"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-xs">
              IA · Software · Integraciones · Productos Digitales
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={`mailto:${SITE.email}`}
                aria-label="Enviar correo a ACOMA"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-background-700 text-foreground-600 hover:text-foreground-950 transition-colors"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950 font-heading mb-4">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © ACOMA. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacidad"
              className="text-xs text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer"
            >
              Privacidad
            </Link>
            <Link
              to="/terminos"
              className="text-xs text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer"
            >
              Términos
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}